import { createContext } from "react";
const AdminAnalyticsProvider = createContext();
export default AdminAnalyticsProvider;
